import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// import BinIcon from '../../assets/icons/bin-icon-dark.inline.svg';
import BinIcon from '../../assets/icons/bin-icon-grey.inline.svg';
import { useJsonApi } from '../../services/GlobalStore/GlobalStore';
import Loading from '../../components/Loading';
import { useModal } from '../../components/Modals/ModalContext';
import messages from './messages';

const RemoveFile = ({
  getDossierItems,
  item,
  setFieldValue,
  fieldname,
  afterRemoveFile,
}) => {
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();
  const [showModal] = useModal('default');

  const openModal = useCallback(() => {
    showModal({
      onConfirm: deleteFile,
      onConfirmText: formatMessage(messages.modalOnConfirm),
      onCancelText: formatMessage(messages.modalOnCancel),
      title: formatMessage(messages.modalMessage),
    });
    // eslint-disable-next-line
  }, []);

  const { del: deleteDossierItem } = useJsonApi(`/dossierItems`, {
    cachePolicy: 'no-cache',
  });

  function deleteFile() {
    setLoading(true);
    deleteDossierItem(item.id).then(() => {
      getDossierItems && getDossierItems();
      setFieldValue && setFieldValue(fieldname, null);
      afterRemoveFile && afterRemoveFile();
      setLoading(false);
    });
  }

  if (loading) {
    return <Loading className="h-10 w-10 flex-shrink-0" viewBox="0 0 40 40" />;
  }

  return (
    <BinIcon
      className="flex-shrink-0 cursor-pointer flex-grow-0 ml-10 text-gray-250"
      onClick={openModal}
    />
  );
};

RemoveFile.propTypes = {
  afterRemoveFile: PropTypes.func,
  fieldname: PropTypes.string,
  getDossierItems: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
};

export default RemoveFile;
